module.exports = __webpack_public_path__ + "static/media/grand-card.b794f188.png";